import { render, staticRenderFns } from "./ActionEditIcon.vue?vue&type=template&id=22e89ea0"
import script from "@/components/action-icon/action-edit-icon/ActionEditIcon.ts?vue&type=script&lang=ts&external"
export * from "@/components/action-icon/action-edit-icon/ActionEditIcon.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/action-icon/action-edit-icon/action-edit-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports